import React from 'react';

export const Camera = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16px"
        height="16px"
        viewBox="0 0 12 12"
        version="1.1"
      >
        <g
          id="Design"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="W3.0-Activate-Kit"
            transform="translate(-418.000000, -470.000000)"
          >
            <g
              id="Activate-your-Kit!"
              transform="translate(40.000000, 72.000000)"
            >
              <g
                id="Enter-Barcode"
                transform="translate(120.000000, 364.000000)"
              >
                <g
                  id="Icon-/-Chevron-/-Down"
                  transform="translate(256.000000, 32.000000)"
                >
                  <rect id="Rectangle" x="0" y="0" width="16" height="16" />
                  <path
                    d="M13.2941176,9.64705882 C13.6596002,9.64705882 13.9602074,9.92482334 13.9963556,10.2807688 L14,10.3529412 L14,12.1176471 C14,13.1213938 13.214361,13.9416447 12.2244627,13.9970202 L12.1176471,14 L10.3529412,14 C9.96309312,14 9.64705882,13.6839657 9.64705882,13.2941176 C9.64705882,12.9286351 9.92482334,12.6280279 10.2807688,12.5918797 L10.3529412,12.5882353 L12.1176471,12.5882353 C12.3575536,12.5882353 12.5555303,12.4087129 12.5845687,12.1766766 L12.5882353,12.1176471 L12.5882353,10.3529412 C12.5882353,9.96309312 12.9042696,9.64705882 13.2941176,9.64705882 Z M2.70588235,9.64705882 C3.07136491,9.64705882 3.37197208,9.92482334 3.40812031,10.2807688 L3.41176471,10.3529412 L3.41176471,12.1176471 C3.41176471,12.3575536 3.59128715,12.5555303 3.82332335,12.5845687 L3.88235294,12.5882353 L5.64705882,12.5882353 C6.03690688,12.5882353 6.35294118,12.9042696 6.35294118,13.2941176 C6.35294118,13.6596002 6.07517666,13.9602074 5.71923119,13.9963556 L5.64705882,14 L3.88235294,14 C2.87860622,14 2.0583553,13.214361 2.00297979,12.2244627 L2,12.1176471 L2,10.3529412 C2,9.96309312 2.31603429,9.64705882 2.70588235,9.64705882 Z M10.9411765,6.82352941 C11.2660499,6.82352941 11.5294118,7.08689132 11.5294118,7.41176471 L11.5294118,8.58823529 C11.5294118,8.91310868 11.2660499,9.17647059 10.9411765,9.17647059 L5.05882353,9.17647059 C4.73395015,9.17647059 4.47058824,8.91310868 4.47058824,8.58823529 L4.47058824,7.41176471 C4.47058824,7.08689132 4.73395015,6.82352941 5.05882353,6.82352941 L10.9411765,6.82352941 Z M6.23529412,2 C6.62514218,2 6.94117647,2.31603429 6.94117647,2.70588235 C6.94117647,3.07136491 6.66341195,3.37197208 6.30746649,3.40812031 L6.23529412,3.41176471 L3.88235294,3.41176471 C3.64244644,3.41176471 3.44446966,3.59128715 3.41543126,3.82332335 L3.41176471,3.88235294 L3.41176471,5.64705882 C3.41176471,6.03690688 3.09573041,6.35294118 2.70588235,6.35294118 C2.3403998,6.35294118 2.03979262,6.07517666 2.00364439,5.71923119 L2,5.64705882 L2,3.88235294 C2,2.87860622 2.78563896,2.0583553 3.77553729,2.00297979 L3.88235294,2 L6.23529412,2 Z M12.1176471,2 C13.1213938,2 13.9416447,2.78563896 13.9970202,3.77553729 L14,3.88235294 L14,5.64705882 C14,6.03690688 13.6839657,6.35294118 13.2941176,6.35294118 C12.9286351,6.35294118 12.6280279,6.07517666 12.5918797,5.71923119 L12.5882353,5.64705882 L12.5882353,3.88235294 C12.5882353,3.64244644 12.4087129,3.44446966 12.1766766,3.41543126 L12.1176471,3.41176471 L9.76470588,3.41176471 C9.37485782,3.41176471 9.05882353,3.09573041 9.05882353,2.70588235 C9.05882353,2.3403998 9.33658805,2.03979262 9.69253351,2.00364439 L9.76470588,2 L12.1176471,2 Z"
                    id="Combined-Shape"
                    fill="#777"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
